import(/* webpackMode: "eager", webpackExports: ["EventClient"] */ "/vercel/path0/app/generator/event/EventClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
